import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'spheres-parallax',
  templateUrl: './parallax-w-privacy-terms.component.html',
  styleUrls: ['./parallax-w-privacy-terms.component.css']
})
export class SpheresParallaxComponent {
  @Input() icons: any;
  @Input() images: any;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY;

    const sphere1 = document.querySelector('.hero-sphere-3') as HTMLElement;
    const sphere2 = document.querySelector('.hero-sphere-1') as HTMLElement;
    const sphere3 = document.querySelector('.hero-sphere-2') as HTMLElement;
    const sphere4 = document.querySelector('.hero-sphere-4') as HTMLElement;
    const sphere5 = document.querySelector('.hero-sphere-5') as HTMLElement;
    const sphere6 = document.querySelector('.hero-sphere-6') as HTMLElement;

    if (sphere1) sphere1.style.transform = `translateY(${scrollY * 0.1}px)`;
    if (sphere2) sphere2.style.transform = `translateY(${scrollY * 0.25}px)`;
    if (sphere3) sphere3.style.transform = `translateY(${scrollY * 0.37}px)`;
    if (sphere4) sphere4.style.transform = `translateY(${scrollY * 0.37}px)`;
    if (sphere5) sphere5.style.transform = `translateY(${scrollY * 0.25}px)`;
    if (sphere6) sphere6.style.transform = `translateY(${scrollY * 0.1}px)`;
  }
}
